// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-card[data-v-5954443c] .el-card__header {\n  padding: 6px 20px;\n  background-color: #f3f3f3;\n}\n", ""]);
// Exports
module.exports = exports;
